import { api } from '@/utils/api'
import { ApiResponseHandler, Postable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaCt120 {
  export namespace Post {
    export interface Request {
      body: {
        answerId: string
        uimData: string
        dataCategory: 'temporary' | 'submitted' // temporary or submitted
      }
    }
    export interface Response {
      // none response parameter.
    }
  }

  export const path: string = '/ta/handWriteData'

  export class Api extends ApiBase implements Postable<Post.Request, Post.Response, ResponseError> {
    public post<R>(
      params: Post.Request,
      successHandler: ApiResponseHandler<Post.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      const validationSample: Post.Response = {}

      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      return this.callbackWrapper<Post.Response, ResponseError, R>(
        api.post<Post.Response>(path, params.body),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
